import { makeStyles, shorthands } from "@fluentui/react-components";

import { themeTokens } from "Core/Theme/M365PulseTheme.types";

export const useStyles = makeStyles({
    root: {
        display: "flex",
        justifyContent: "space-between",
        ...shorthands.border(0),
        backgroundColor: themeTokens.siteHeaderBackgroundColor,
        alignItems: "center",
        "> div": {
            flexGrow: 1
        }
    },
    timezone: {
        paddingLeft: "10px"
    },
    rightItemContainer: {
        display: "flex",
        justifyContent: "end",
        alignItems: "center",
        paddingLeft: "10px",
        marginRight: "1px",
        marginLeft: "auto"
    }
});
